import { useEffect, useState } from 'react';
import { Fetch } from '../helpers/fetchWrapper';

const STATUS = {
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};

const offerService = {
  _url: `${process.env.REACT_APP_USER_API_URL}/offers`,

  GetAllOffers(searchQuery, fetch) {
    const [offers, setOffers] = useState({
      items: [],
      totalItems: 0,
    });
    const [offerStatus, setOfferStatus] = useState(STATUS.LOADING);

    useEffect(() => {
      setOfferStatus(STATUS.LOADING);
      offerService
        .getAllOffers(searchQuery)
        .then(res => {
          setOffers({
            items: res?.items || [],
            totalItems: res?.totalItems || 0,
          });
          setOfferStatus(STATUS.SUCCESS);
        })
        .catch(() => setOfferStatus(STATUS.ERROR));
    }, [JSON.stringify(searchQuery), fetch]);

    return {
      offers_loading: offerStatus === STATUS.LOADING,
      offers_error: offerStatus === STATUS.ERROR,
      offers_data: offers,
    };
  },

  async getAllOffers({ page = 1, itemsPerPage = 10, search = '', searchText = '', getAll = false, startDate = '', endDate = '' } = {}) {
    const q = searchText || search || '';
    let res = await Fetch.get(
      `${this._url}?page=${page}&itemsPerPage=${itemsPerPage}&search=${encodeURIComponent(q)}&getAll=${getAll}&startDate=${startDate}&endDate=${endDate}`,
    );
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res.data;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async getOfferById(id) {
    let res = await Fetch.get(`${this._url}/${id}`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async createOffer(payload) {
    let res = await Fetch.post(`${this._url}`, payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const body = await res.json();
    const message = Array.isArray(body?.message) ? body.message.join(', ') : body?.message;
    throw new Error(message ?? 'Something went wrong');
  },

  async updateOffer(id, payload) {
    let res = await Fetch.put(`${this._url}/${id}`, payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const body = await res.json();
    const message = Array.isArray(body?.message) ? body.message.join(', ') : body?.message;
    throw new Error(message ?? 'Something went wrong');
  },

    async deleteOffer(id) {
    let res = await Fetch.delete(`${this._url}/${id}`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
};

export default offerService;
